let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => {
      try {
        return callback(data);
      } catch (e) {
        console.error('PubSub subscriber error:', e);
        return Promise.resolve();
      }
    });
    // Use allSettled so one failing subscriber doesn't break others
    return Promise.allSettled(promises);
  }
  return Promise.resolve();
}
